/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_total_price = /** @type {(inputs: {}) => string} */ () => {
	return `Celková cena`
};

const da_total_price = /** @type {(inputs: {}) => string} */ () => {
	return `Totalpris`
};

const de_total_price = /** @type {(inputs: {}) => string} */ () => {
	return `Gesamtpreis`
};

const en_total_price = /** @type {(inputs: {}) => string} */ () => {
	return `Total price`
};

const es_total_price = /** @type {(inputs: {}) => string} */ () => {
	return `Precio total`
};

const fr_total_price = /** @type {(inputs: {}) => string} */ () => {
	return `Prix total`
};

const hu_total_price = /** @type {(inputs: {}) => string} */ () => {
	return `Teljes ár`
};

const it_total_price = /** @type {(inputs: {}) => string} */ () => {
	return `Prezzo totale`
};

const nl_total_price = /** @type {(inputs: {}) => string} */ () => {
	return `Totale prijs`
};

const pl_total_price = /** @type {(inputs: {}) => string} */ () => {
	return `Cena całkowita`
};

const pt_total_price = /** @type {(inputs: {}) => string} */ () => {
	return `Preço total`
};

const sv_total_price = /** @type {(inputs: {}) => string} */ () => {
	return `Totalt pris`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const total_price = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.total_price(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("total_price", locale)
	if (locale === "cs") return cs_total_price(inputs)
	if (locale === "da") return da_total_price(inputs)
	if (locale === "de") return de_total_price(inputs)
	if (locale === "en") return en_total_price(inputs)
	if (locale === "es") return es_total_price(inputs)
	if (locale === "fr") return fr_total_price(inputs)
	if (locale === "hu") return hu_total_price(inputs)
	if (locale === "it") return it_total_price(inputs)
	if (locale === "nl") return nl_total_price(inputs)
	if (locale === "pl") return pl_total_price(inputs)
	if (locale === "pt") return pt_total_price(inputs)
	return sv_total_price(inputs)
};